import { Inject, Injectable } from '@angular/core'
import { Observable, defer, filter, from, shareReplay } from 'rxjs'
import { APP_CONFIG } from 'src/app/app.config'
import { AppConfigModel } from '../models'

@Injectable({
  providedIn: 'root',
})
export class MaintenanceNoticeService {
  private readonly noticeUrl: string | undefined

  public readonly notice$: Observable<string> = defer(() => from(this.loadNotice())).pipe(
    filter((notice): notice is string => notice !== null),
    shareReplay({ bufferSize: 1, refCount: false }),
  )

  constructor(@Inject(APP_CONFIG) config: AppConfigModel) {
    const baseUrl = config.rcs_frontend_assets_base_url?.replace(/\/$/, '')
    if (baseUrl) {
      this.noticeUrl = `${baseUrl}/maintenance-${config.environment}.txt${config.rcs_frontend_assets_sas_token ?? ''}`
    }
  }

  private async loadNotice(): Promise<string | null> {
    if (!this.noticeUrl) {
      return null
    }

    try {
      const response = await fetch(this.noticeUrl, { cache: 'no-store' })
      if (!response.ok) {
        return null
      }

      return (await response.text()).trim()
    } catch {
      return null
    }
  }
}
